import { apiPost, apiGet } from 'lib/apiClient'

/**
 * Login with email and password
 */
export async function login(email, password) {
  const { data, error } = await apiPost('/auth/login/', {
    email,
    password,
  }, { skipAuth: true })
  
  if (error) throw new Error(error)
  
  // Store session
  const session = {
    access_token: data.access_token,
    refresh_token: data.refresh_token,
    user: data.user,
    profile: data.profile,
  }
  
  localStorage.setItem('auth_session', JSON.stringify(session))
  
  return data
}

/**
 * Logout
 */
export async function logout() {
  const session = localStorage.getItem('auth_session')
  
  if (session) {
    try {
      const sessionData = JSON.parse(session)
      if (sessionData.refresh_token) {
        // Call logout endpoint to blacklist token
        await apiPost('/auth/logout/', {
          refresh_token: sessionData.refresh_token,
        }).catch(() => {
          // Ignore errors on logout
        })
      }
    } catch (e) {
      // Ignore errors
    }
  }
  
  localStorage.removeItem('auth_session')
}

/**
 * Get current user info
 */
export async function getCurrentUser() {
  const { data, error } = await apiGet('/auth/me/')
  if (error) throw new Error(error)
  return data
}



